import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import BrowserPersistence from "@overrides_venia/peregrine/util/simplePersistence";
import { removeCart } from "../cart";
import { setMemberAttributeFilters } from "../catalog";
import { reset } from "../bookTable";
import { clearCheckoutDataFromStorage } from "../checkout";
import actions from "./actions";
import { parseJwt } from "@Src_main/utils/generalUtils";
import { deriveMemberAttributes } from "@Src_main/utils/memberAttributes";
const storage = new BrowserPersistence();
function removeTypename(obj) {
  if (Array.isArray(obj)) {
    return obj.map(removeTypename);
  } else if (typeof obj === 'object' && obj !== null) {
    const newObj = {};
    for (const [key, value] of Object.entries(obj)) {
      if (key !== '__typename') {
        newObj[key] = removeTypename(value);
      }
    }
    return newObj;
  } else {
    return obj;
  }
}
export const signOut = function () {
  let payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return async function thunk(dispatch) {
    const {
      revokeToken
    } = payload;
    if (revokeToken) {
      // Send mutation to revoke token.
      try {
        await revokeToken();
      } catch (error) {
        console.error("Error Revoking Token", error);
      }
    }

    // Remove token from local storage and Redux.
    await dispatch(clearToken());
    await dispatch(actions.reset());
    await clearCheckoutDataFromStorage();
    await dispatch(reset());
    // Now that we're signed out, forget the old (customer) cart.
    // We don't need to create a new cart here because we're going to refresh
    // the page immediately after.
    dispatch(setMemberAttributeFilters([]));
    await dispatch(removeCart());
  };
};
export const getUserDetails = _ref => {
  let {
    fetchUserDetails
  } = _ref;
  return async function thunk() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const [dispatch, getState] = args;
    const {
      user
    } = getState();
    if (user.isSignedIn) {
      dispatch(actions.getDetails.request());
      try {
        var _data$customer, _data$customer$lsAcco;
        const {
          data
        } = await fetchUserDetails({
          fetchPolicy: "network-only"
        });
        const addressesCleaned = (data.customer.addresses || []).map(removeTypename);
        const customerEnriched = _objectSpread(_objectSpread({}, data.customer), {}, {
          addresses: addressesCleaned
        });
        dispatch(actions.getDetails.receive(customerEnriched));

        // Set member attribute filters based on customer attributes (CONVE, CONV_ND)
        const customerAttributes = ((_data$customer = data.customer) === null || _data$customer === void 0 ? void 0 : (_data$customer$lsAcco = _data$customer.lsAccount) === null || _data$customer$lsAcco === void 0 ? void 0 : _data$customer$lsAcco.customer_attributes) || [];
        const memberAttributes = deriveMemberAttributes(customerAttributes);
        dispatch(setMemberAttributeFilters(memberAttributes));
      } catch (error) {
        if (error.message === "The current customer isn't authorized.") {
          await dispatch(clearToken());
        }
        dispatch(actions.getDetails.receive(error));
        // Clear member filters on error
        dispatch(setMemberAttributeFilters([]));
      }
    }
  };
};
export const resetPassword = _ref2 => {
  let {
    email
  } = _ref2;
  return async function thunk() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    const [dispatch] = args;
    dispatch(actions.resetPassword.request());

    // TODO: actually make the call to the API.
    // For now, just return a resolved promise.
    await Promise.resolve(email);
    dispatch(actions.resetPassword.receive());
  };
};
export const setToken = token => async function thunk() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  const [dispatch] = args;
  // Store token in local storage.
  // TODO: Get correct token expire time from API
  const jwtDecoded = parseJwt(token);
  const ttlToken = Math.floor((jwtDecoded.exp * 1000 - Date.now()) / 1000);
  storage.setItem("signin_token", token, ttlToken);

  // Persist in store
  dispatch(actions.setToken(token));
};
export const setGuestCartId = cartId => async function thunk() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }
  const [dispatch] = args;
  dispatch(actions.setGuestCartId(cartId));
};
export const clearToken = () => async function thunk() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }
  const [dispatch] = args;

  // Clear token from local storage
  storage.removeItem("signin_token");

  // Remove from store
  dispatch(actions.clearToken());
};
export const submitIsSigningIn = payload => async function thunk(dispatch) {
  dispatch(actions.isSigningIn.submit(payload));
};